var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","align-center":""}},[(_vm.isLoginFormShow)?_c('ComponentLogin',{on:{"showRegister":_vm.isShowRegister,"getUsername":_vm.getUsername}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }